export enum CalloutSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
